import { render, staticRenderFns } from "./Scrapper.vue?vue&type=template&id=07602f02&"
import script from "./Scrapper.vue?vue&type=script&lang=js&"
export * from "./Scrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports